import React from "react"
import Provider from "./src/providers"
import "semantic-ui-css/semantic.min.css"

export const shouldUpdateScroll = () => {
  document.body.scrollTop = 0
}

export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>
